import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialCheckModel } from '@evorait/pace-core';
import { FormArray } from '@angular/forms';
import { faChevronDown, faChevronUp, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-material-order-row-details',
    templateUrl: './material-order-row-details.component.html',
    styleUrls: ['./material-order-row-details.component.scss'],
    standalone: false,
})
export class MaterialOrderRowDetailsComponent {
    @Input()
    public material: MaterialCheckModel;

    @Input()
    public parentForm: FormArray | undefined;

    @Input()
    public displayOptions: MaterialOrderRowDisplayOptions;

    @Output()
    public deleteMaterial: EventEmitter<void> = new EventEmitter();

    public isCollapsed = true;

    protected readonly faChevronUp = faChevronUp;
    protected readonly faChevronDown = faChevronDown;
    protected readonly faTrashAlt = faTrashAlt;
}

export interface MaterialOrderRowDisplayOptions {
    displayTs: boolean;
    displayNdf: boolean;
    displayStorageLocation: boolean;
    displayAvailable: boolean;
    displayCustomerPrice: boolean;
    displayRepairPrice: boolean;
}
